// removed by extract-text-webpack-plugin
module.exports = {"error":"purify_NotFound__error___1kUBP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFound/NotFound.scss
// module id = 292
// module chunks = 0